import request from './request';

// 获取广告列表
export function getAdvertisementList() {
  return request({
    url: '/api/advertisements/list',
    method: 'get'
  });
}

// 根据ID获取广告详情
export function getAdvertisementById(id) {
  return request({
    url: `/api/advertisements/${id}`,
    method: 'get'
  });
}

// 创建广告
export function createAdvertisement(data) {
  return request({
    url: '/api/advertisements',
    method: 'post',
    data
  });
}

// 更新广告
export function updateAdvertisement(id, data) {
  return request({
    url: `/api/advertisements/${id}`,
    method: 'put',
    data
  });
}

// 删除广告
export function deleteAdvertisement(id) {
  return request({
    url: `/api/advertisements/${id}`,
    method: 'delete'
  });
}

// 更新广告排序
export function updateAdvertisementSortOrder(id, newSortOrder) {
  return request({
    url: `/api/advertisements/${id}/sort-order`,
    method: 'put',
    params: { newSortOrder }
  });
}